import { jsx } from "react/jsx-runtime";
import { Spacer } from "@zillow/constellation";
import { CustomPropTypes } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
const BlockSpacer = ({
  attrs,
  index
}) => {
  const {
    paddingTop = {
      default: "lg",
      lg_lte: "md",
      sm_lte: "sm"
    }
  } = attrs;
  return /* @__PURE__ */ jsx(Spacer, { "data-testid": "spacer", paddingTop }, index);
};
BlockSpacer.propTypes = {
  attrs: PropTypes.shape({
    paddingTop: CustomPropTypes.inlineMediaQuery(PropTypes.string)
  }),
  index: PropTypes.number
};
export {
  BlockSpacer as default
};
